import { useCustomDatePickerRange } from './custom-date-picker-range.model'
import type { ICustomDatePickerRange } from './custom-date-picker-range.types'
import { CustomDatePickerRangeView } from './custom-date-picker-range.view'

/**
 * Bridge over the design-system `DateRangePickerDropdown`. Keeps the product
 * `options` / `selected` / `onChange(option)` contract its consumers rely on;
 * the model maps it onto the DS API and the view renders it.
 */
export default function CustomDatePickerRange(props: Readonly<ICustomDatePickerRange>) {
  const viewProps = useCustomDatePickerRange(props)

  return <CustomDatePickerRangeView {...viewProps} />
}
